// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1lTfj","info":"Note_info__1CN62","note":"Note_note__3XseO","actions":"Note_actions__2muva"};